module.exports = __webpack_public_path__ + "img/stripe.7a999e26.png";